module.exports = __webpack_public_path__ + "img/models.d353ecbd.png";